import { useEffect } from 'react'
import { useConsent } from '../consent/ConsentContext'
import { initPixel, revokePixel, trackPageView, trackEvent } from '../pixel/FacebookPixel'

/**
 * Hook that manages Facebook Pixel lifecycle based on consent state.
 * Initializes pixel when marketing consent is granted,
 * revokes when consent is withdrawn.
 * Also fires ViewContent/Schedule events based on URL path.
 */
export function useConsentPixel(): void {
    const { consent, hasDecided } = useConsent()

    useEffect(() => {
        if (!hasDecided || !consent) return

        if (consent.marketing) {
            initPixel()
            trackPageView()

            // Fire ViewContent for relevant pages
            if (typeof window !== 'undefined') {
                const path = window.location.pathname
                if (path.startsWith('/produkte') || path.startsWith('/karriere') || path.startsWith('/standorte')) {
                    trackEvent('ViewContent', { content_category: path.split('/')[1] })
                }
                if (path.startsWith('/mittagstisch') || path.startsWith('/fruehstueck')) {
                    trackEvent('Schedule', { content_category: path.split('/')[1] })
                }
            }
        } else {
            revokePixel()
        }
    }, [consent, hasDecided])
}
